import { render, staticRenderFns } from "./HistoricoAntecipacoes.vue?vue&type=template&id=5c62b3d9&scoped=true"
import script from "./HistoricoAntecipacoes.vue?vue&type=script&lang=ts"
export * from "./HistoricoAntecipacoes.vue?vue&type=script&lang=ts"
import style0 from "./HistoricoAntecipacoes.vue?vue&type=style&index=0&id=5c62b3d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62b3d9",
  null
  
)

export default component.exports